import type { FormApi } from '../../../form-hooks/useFormApi';
import type { NewMediaUploadFn } from '../../../hooks/api/useMediaUpload';
import type {
  ContentObject,
  ContentTypeDefinition,
  WithOptionalInternalProps,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type FormAddElementEventInit = {
  /** Content type that includes the field */
  contentType: WithOptionalInternalProps<ContentTypeDefinition>;
  /** An instance of form */
  form: FormApi;
  /** Function to upload media files (mostly for media relations) */
  onMediaUpload: NewMediaUploadFn;
  /**
   * Initial data of the content object.
   * This will be either a new object or the object being edited.
   */
  initialData: WithOptionalInternalProps<ContentObject>;
  /**
   * Unique key for form.
   * Use it to distinguish different forms rendered at the same time.
   * For example when user compares different versions of the object in the UI.
   */
  formUniqueKey: string;
};

/**
 * An event that is rendering additional element at start in the content object form.
 * It also renders at webhook form page.
 *
 * @memberof FlotiqPlugins.Events
 * @eventName "flotiq.form::add"
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to add additional field to content object form.
 */
export class FormAddElementEvent extends IFlotiqPluginEvent {
  constructor(initData: FormAddElementEventInit) {
    super(initData);
  }
}
